// To be used for the heading part

import * as React from "react";
import moment from "moment";
import { toINR } from "../../../../service/numberFormat";

export interface IOpQuotesHeadingMobProps {
	dpNm: string;
	ltp?: string;
	chLTP?: string;
	chLTPPer?: string;
	exc?: string;
	ltt?: string;
	expiry?: string;
	dateRange?: string;
}

const OpQuotesHeadingMob: React.FC<IOpQuotesHeadingMobProps> = props => {
	return (
		<div className="op_quotes_heading">
			<div className="left">
				<h1 className="symbol">
					{props.dpNm || "--"}
					{props.exc && <span className="exchange">{props.exc}</span>}
				</h1>
				{props.expiry && <div className="expiry">{props.expiry}</div>}
				{props.ltt && (
					<div className="time">
						<span className={"circle " + (+props.chLTP! > 0 ? "green" : +props.chLTP! < 0 ? "red" : "")}></span>
						{moment(props.ltt).format("hh:mm:ss A")}
					</div>
				)}
			</div>
			<div className="right">
				{props.ltp && <div className="ltp">{toINR(props.ltp)}</div>}
				{props.chLTP && (
					<div className={"change_row " + (+props.chLTP! > 0 ? "green" : +props.chLTP! < 0 ? "red" : "")}>
						{props.chLTP} ({props.chLTPPer}%)
					</div>
				)}
				{props.dateRange && <div className="time">{props.dateRange}</div>}
			</div>
		</div>
	);
};

export default OpQuotesHeadingMob;
